import Vue from 'vue';
import VueI18n from 'vue-i18n';

import Api from '../services/api';
import fallbackTranslates from './translates/fallback.json';
import { useMemoize } from '@vueuse/core';

Vue.use(VueI18n);

const NO_LOCALE = 'none';
const FALLBACK_LOCALE = 'fallback-locale';
let isInit = {};

const i18nInstance = new VueI18n({
  locale: NO_LOCALE,
});

export const i18n = i18nInstance;

export const isI18nLoaded = () => i18nInstance.locale !== NO_LOCALE;

export const i18nLoadTranslations = (locale, translationMessages) => {
  i18nInstance.locale = locale;
  i18nInstance.mergeLocaleMessage(locale, translationMessages);
};

export const i18nSetPublicLocale = useMemoize((locale) => i18nSetLocale(locale, 'public'));
export const i18nSetMemberLocale = useMemoize((locale) => i18nSetLocale(locale, 'member'));

const i18nSetLocale = async (locale, scope) => {
  const translationsUrl = 'https://' + FRONT_CDN_HOST + `/translations/${scope}.${locale}.json`;

  if (isInit[scope]) {
    return isInit[scope];
  }

  try {
    const translations = await Api().get(translationsUrl).then(({ data }) => data);
    isInit[scope] = translations;
    i18nLoadTranslations(locale, translations);
  } catch (e) {
    i18nLoadTranslations(FALLBACK_LOCALE, fallbackTranslates);
  }
};
